<!-- HTML -->
<template>
  <div>
    <h1 class="title is-1">SERVICIOS</h1>

    <div class="columns is-centered is-mobile">
      <div class="column is-four-fifths">
        <div class="columns is-multiline">
          <div class="column is-three-fifths">
            <div class>
              <h1 class="title is-3">
                Versión 1:
                <i class="green">Menús QR</i>
              </h1>La crisis sanitaria provocada por la pandemia del Covid-19, ha creado un nuevo factor a tomar en cuenta al escoger a qué restaurante ir:
              <b
                class="green"
              >la higiene.</b>
              Para poder hacerle frente a esta nueva realidad se creó el servicio de
              <i>
                <b class="green">Menuly "Menús QR"</b>
              </i>, el cual facilita a los restaurantes a que sus clientes puedan acceder al menú
              de forma virtual, escaneando un 
              <b class="green">código QR</b> y visualizarlo desde su dispositivo móvil.
              <br />¡Prueba este código QR!
            </div>
            <br />
            <div class="bottom">
              <!--<router-link to="/Solicitar_QR" class="button is-large green-bg">Solicitar un QR</router-link>-->
              <a href="mailto:bernardo.altamirano@menuly.page?subject=Solicitar un QR&body=¡Hola! 
              %0d%0aMe gustaría cotizar un código QR para <llenar número de sucursales> sucursal/es." class="button is-large green-bg">Solicitar un QR</a>
            </div>
          </div>
          <div class="column is-two-fifths">
            <img src="../assets/contacto.png" alt="Código QR" />
          </div>
        </div>
      </div>
    </div>

    <div class="columns is-centered is-mobile">
      <div class="column centered">
        <div class="wide-separator-line"></div>
      </div>
    </div>
    <div class="columns is-centered is-mobile">
      <div class="column is-four-fifths">
        <div class="columns is-multiline">
          <div class="column is-three-fifths">
            <div>
              <h1 class="title is-3">
                Versión 2:
                <i class="light-blue">Menús Inteligentes</i>
              </h1>El segundo reto a superar en los restuarantes es el
              <b
                class="light-blue"
              >flujo de clientes</b>; para reducir el riesgo de contagio, los negocios deben de
              <b
                class="light-blue"
              >optimizar</b>
              su logística para no tener congestión de personas esperando a ser servidas. Para ello, se creó el servicio de
              <i>
                <b class="light-blue">Menuly "Menús Inteligentes"</b>
              </i> ,
              el cual permite a los clientes visualizar el menú desde sus dispositivos móviles y agregar los productos que desean
              <b
                class="light-blue"
              >ordenar.</b> 
              <!--Una vez realizado, los meseros
              sabrán lo que los clientes quieren pedir al escanear un nuevo código que genera cada orden.
              -->
            </div>
            <br />
            <div class="bottom">
              <a
                href="mailto:bernardo.altamirano@menuly.page"
                class="button is-large light-blue-bg"
              >Más información</a>
            </div>
          </div>
          <div class="column is-two-fifths">
            <img src="../assets/qrUsers.png" alt="beca" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-centered is-mobile">
      <div class="column centered">
        <div class="wide-separator-line"></div>
      </div>
    </div>
    <div class="columns is-centered is-mobile">
      <div class="column is-four-fifths">
        <div class="columns is-multiline">
          <div class="column is-three-fifths">
            <h1 class="title is-3">
              Versión 3:
              <i class="blue">Applicación Menuly</i>
            </h1>Finalmente, crearemos una aplicación para eliminar el tercer foco de contagio:
            <b
              class="blue"
            >pagar la cuenta</b>. Con la
            <i>
              <b class="blue">Aplicación Menuly</b>
            </i>, los clientes podrán escanear el código QR, hacer su pedido y
            <b
              class="blue"
            >realizar su pago</b>; ¡todo esto sin necesidad de
            tocar cartas, cuentas o terminales bancarias! La aplicación está en etapa de desarrollo, pero los restaurantes interesados pueden
            <b
              class="blue"
            >suscribirse</b> para ser
            los primeros en tenerla en cuanto se libere para iOS y Android.
            <br />
            <br />
            <div class="bottom">
              <a href="mailto:bernardo.altamirano@menuly.page" class="button is-large blue-bg">Suscribirse</a>
            </div>
          </div>
          <div class="column is-two-fifths">
            <img src="../assets/pago.png" alt="beca" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- JS -->
<script>
export default {
  name: "servicios"
};
</script>

<!-- SCSS -->
<style scoped lang="scss">
.word {
  color: #095168;
}
.foto {
  width: 215px;
}
.column {
  text-align: justify;
  padding-left: 5%;
  padding-right: 5%;
}
.wide-separator-line {
  height: 1px;
  background-color: #5c5b5b;
  margin: 5% 20px;
}
.qr {
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 10px;
  width: 25%;
  position: relative;
  top: 50%;
}
.bottom {
  position: relative;
  bottom: 0%;
}
.is-70-tall {
  height: 70%;
}
.green {
  color: #9ed96b;
}
.light-blue {
  color: #095168;
}
.blue {
  color: #0d0635;
}
.green-bg {
  background-color: #9ed96b;
  color: white;
}
.light-blue-bg {
  background-color: #095168;
  color: white;
}
.blue-bg {
  background-color: #0d0635;
  color: white;
}
</style>
